import { digitalDeliveryFormToQuery as formToQuery , digitalDeliveryAllFormToQuery as formToQueryAll} from './digitalDeliveryFormToQuery';
import {
  digitalDeliveryServiceQueryToForm as serviceQueryToForm,
  digitalDeliveryQueryToForm as queryToForm,
} from "./digitalDeliveryQueryToForm";

export default { queryToForm, serviceQueryToForm, formToQuery , formToQueryAll};
